exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h-text-color[data-v-9de89b86] {\n  color: rgba(6, 38, 62, 0.84);\n}\n.name-title[data-v-9de89b86] {\n  font-size: 14px;\n  font-weight: 500;\n  color: #06263e;\n}\n", ""]);

// exports
